import { forwardRef } from "react";

export interface FileUploaderInputProps {
  name: string;
  html?: { multiple: boolean; class: string };
}

export const FilesUploadInput = forwardRef(function FilesUploadInput(
  {
    name,
    html,
    onChange,
    accept,
  }: FileUploaderInputProps & {
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    accept: string;
  },
  ref: React.Ref<HTMLInputElement>
) {
  const isMultiple = !!html?.multiple;

  return (
    <input
      type="file"
      className="file-uploader-input-js"
      multiple={isMultiple}
      name={name}
      style={{ display: "none" }}
      ref={ref}
      onChange={onChange}
      accept={accept}
    />
  );
});
